import * as React from "react";

function SvgTrayIo(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 53 59"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path fill="#D2B53C" d="M17 14.7L8.5 9.8 0 14.7v9.8l8.5 4.9 8.5-4.9z" />
      <path fill="#F1DE44" d="M17 14.7l-8.5 4.9v9.8l8.5-4.9z" />
      <path fill="#4FA7B8" d="M42.5 9.8l-17 9.8v9.8l8.5 4.9 17-9.8v-9.8z" />
      <path fill="#65CCEB" d="M51 14.7l-17 9.8v9.8l17-9.8z" />
      <path fill="#D58040" d="M34 24.5l-8.5 4.9v9.8l17 9.9 8.5-4.9v-9.9z" />
      <path fill="#F99F47" d="M51 34.3l-8.5 4.9v9.9l8.5-4.9z" />
      <g>
        <path fill="#B48" d="M34 4.9L25.5 0 17 4.9v24.5l8.5 4.9 8.5-4.9V4.9" />
        <path fill="#E05292" d="M34 29.4V4.9l-8.5 4.9v24.5z" />
      </g>
      <g>
        <path
          fill="#61A04B"
          d="M17 44.2V54l8.5 4.9L34 54V24.5l-8.5-4.9L0 34.3v9.9l8.5 4.9"
        />
        <path fill="#77C262" d="M34 24.5L8.5 39.2v9.9l17-9.9v19.7L34 54z" />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgTrayIo);
